import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Settings, X, Lock } from "lucide-react";
import { AdminSection } from "./AdminSection";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const AdminPasswordGate = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handlePasswordSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const { data, error } = await supabase.functions.invoke("verify-admin-password", {
        body: { password },
      });

      if (error) throw error;

      if (data?.success) {
        setIsAuthenticated(true);
        toast.success("Zugang gewährt");
      } else {
        toast.error("Falsches Passwort");
      }
    } catch {
      toast.error("Fehler bei der Überprüfung");
    } finally {
      setIsLoading(false);
      setPassword("");
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsAuthenticated(false);
  };

  return (
    <div className="bg-[#243949]">
      {isOpen ? (
        isAuthenticated ? (
          <>
            <AdminSection />
            <div className="container mx-auto px-4 pb-8">
              <Button
                onClick={handleClose}
                variant="outline"
                className="w-full max-w-lg mx-auto flex items-center justify-center gap-2 bg-white/10 border-white/20 text-white hover:bg-white/20"
              >
                <X className="w-4 h-4" />
                Admin-Bereich schließen
              </Button>
            </div>
          </>
        ) : (
          <div className="container mx-auto px-4 py-8">
            <form onSubmit={handlePasswordSubmit} className="w-full max-w-sm mx-auto space-y-4">
              <div className="flex items-center gap-2 text-white mb-2">
                <Lock className="w-4 h-4" />
                <span className="text-sm font-medium">Admin-Passwort eingeben</span>
              </div>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Passwort"
                className="bg-white/10 border-white/20 text-white placeholder:text-white/50"
              />
              <div className="flex gap-2">
                <Button type="submit" disabled={isLoading || !password} className="flex-1">
                  {isLoading ? "Prüfe..." : "Einloggen"}
                </Button>
                <Button type="button" variant="outline" onClick={() => setIsOpen(false)} className="bg-white/10 border-white/20 text-white hover:bg-white/20">
                  Abbrechen
                </Button>
              </div>
            </form>
          </div>
        )
      ) : (
        <div className="container mx-auto px-4 py-8">
          <Button
            onClick={() => setIsOpen(true)}
            variant="outline"
            className="w-full max-w-lg mx-auto flex items-center justify-center gap-2 bg-white/10 border-white/20 text-white hover:bg-white/20"
          >
            <Settings className="w-4 h-4" />
            Admin-Bereich
          </Button>
        </div>
      )}
    </div>
  );
};
